export default __webpack_public_path__ + "static/media/prenseslina3.7cf754ab.jpg";